import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ user, children }) => {
    // إحنا شلنا الـ useEffect والـ state لأن البيانات جاية جاهزة من App.js
    
    // لو مفيش مستخدم، يرجعه لصفحة تسجيل الدخول
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // لو فيه مستخدم، يعرض المحتوى (الداشبورد)
    return children;
};

export default ProtectedRoute;